module.exports = __webpack_public_path__ + "static/HudsonRiver-c96dd29cdea0e4e63b9a2359897007fc.png";